import {connect} from 'react-redux';
import SupporterEmergencyContactBlock from '../../../components/blocks/supporter/SupporterEmergencyContactBlock';
import {
    getEmergencyContact,
    changeValue,
    editEmergencyContact,
    saveEmergencyContact
} from '../../../actions/supporterEmergencyContactAction';

const mapStateToProps = (state, ownProps) => {
    return {
        supporterId: ownProps.supporterId,
        supporterEmergencyContact: state.supporterEmergencyContact
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getEmergencyContact(id) {
            dispatch(getEmergencyContact(id))
        },
        handleInputChange(e) {
            dispatch(changeValue(e.target.name, e.target.value))
        },
        editEmergencyContact() {
            dispatch(editEmergencyContact())
        },
        handleFormSubmit(data) {
            dispatch(saveEmergencyContact(data))
        }
    }
};

const SupporterEmergencyContactBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupporterEmergencyContactBlock);

export default SupporterEmergencyContactBlockContainer;